export default class About {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.animationStarted = false;
        this.init();
    }

    init() {
        const aboutImages = this.el.querySelector('.about__images');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    aboutImages.classList.add('animate');
                } else {
                    aboutImages.classList.remove('animate');
                }
            });
        }, { threshold: 0.5 });

        observer.observe(aboutImages);
    }
}
